import { useConfig } from "../../../Providers/ConfigProvider"
import { GetLastPriceListGenerateDateForCustomer } from "../../../Services/ProductService"

const useCheckCustomerHasPriceList = () => {
    const { api } = useConfig()

    const checkCustomerHasPriceList = async (custId) => {
        try {
            const res = await GetLastPriceListGenerateDateForCustomer(api, custId)
            return res.data.trim() !== '' && res.data !== '0001-01-01T00:00:00' ? true : false
        } catch (error) {
            console.log(error)
            return false
        }
    }

    return { checkCustomerHasPriceList }
}

export default useCheckCustomerHasPriceList